import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-info-window',
  templateUrl: './info-window.component.html',
  styleUrls: ['./info-window.component.scss'],
  standalone: false
})
export class InfoWindowComponent {
  @Input() showIcon: boolean = true;
  @Input() infoText: string = '';
  @Input() infoTitle: string = '';
  @Input() showInfoBoxOutside: boolean = false;
  
  // New structured content inputs
  @Input() mainTitle: string = '';
  @Input() mainText: string = '';
  @Input() items: { subTitle?: string, subText?: string, subList?: string[], subFooter?: string }[] = [];
  @Input() mainFooter: string = '';
  
  // Custom HTML input for when you want full control
  @Input() customHtml: string = '';

  @Input() showInfoModal?: boolean = false;

  constructor() {}

  showInfoPopover(event?: Event) {
    this.showInfoModal = true;
  }

  closeModal() {
    this.showInfoModal = false;
  }
}


